module.exports.meritsOptions = [
  {
    name: "Linguistics",
    description:
      "Each dot of Linguistics allows the character to read, write and speak fluently in another language outside of the default two they already know, which is their native language and the language of the Domain.",
    rating: 1,
    flaw: false,
    modifier: 1,
    group: "Linguistics",
  },
  {
    name: "Beautiful",
    description: "Add one die to related Social pools",
    rating: 2,
    flaw: false,
    modifier: 1,
    group: "Looks",
  },
  {
    name: "Stunning",
    description: "Add two dice to related Social pools",
    rating: 4,
    flaw: false,
    modifier: 2,
    group: "Looks",
  },
  {
    name: "Semblance of the Methuselah",
    description:
      "With an appearance strikingly similar to a methuselah, gain one die on rolls to impress, intimidate or attract the attention who recognize your face. As well as gain other bonuses such as status or additional die when meeting the methuselah they resemble.",
    rating: 1,
    flaw: false,
    modifier: 1,
    group: "Looks",
  },
  {
    name: "Famous Face",
    description:
      "Appear as someone famous and gain two dice in social tests where this works to their benefit. Take a two-dice penalty whenever they attempt to hide in a crowd or avoid recognition.",
    rating: 1,
    flaw: false,
    modifier: 2,
    group: "Looks",
  },
  {
    name: "Ingénue",
    description:
      "They appear innocent and blameless, add two dice to any rolls related to avoiding suspicion or deflecting blame at the Storytellers’ discretion.",
    rating: 1,
    flaw: false,
    modifier: 2,
    group: "Looks",
  },
  {
    name: "Remarkable Feature",
    description:
      "Possessing a rare, memorable feature such as eye color or unusual complexion. Add two-dice to social interactions with strangers and take a one-die penalty to disguise yourself.",
    rating: 1,
    flaw: false,
    modifier: 2,
    group: "Looks",
  },
  {
    name: "Up All Night",
    description:
      "Treat Humanity as one higher (Max 10), or two dots higher if taken at four dots when using Blush of Life, eating, drinking, or sexual intercourse.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Looks",
  },
  {
    name: "High Functioning Addict",
    description:
      "Add one die to either Physical, Social, or Mental pool when the last feeding had the drug of their desire.",
    rating: 1,
    flaw: false,
    modifier: 1,
    group: "Substance Abuse",
  },
  {
    name: "Bond Resistance",
    description: "Add one die to resist Blood Bonds per level of this merit.",
    rating: 1,
    flaw: false,
    modifier: 1,
    group: "Bonding",
  },
  {
    name: "Short Bond",
    description: "Bonds decrease by two levels each month if not reinforced.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Bonding",
  },
  {
    name: "Unbondable",
    description: "Unable to be bonded.",
    rating: 5,
    flaw: false,
    modifier: 0,
    group: "Bonding",
  },
  {
    name: "Bloodhound",
    description:
      "Able to sniff out resonances without tasting them. Resolve + Awareness test at Diffiuculty 3. Adjust up or down based on how close and other factors such as perfume.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Feeding",
  },
  {
    name: "Iron Gullet",
    description:
      "Able to consume rancid, defractionated, or otherwise unedible blood to other vampires.",
    rating: 3,
    flaw: false,
    modifier: 0,
    group: "Feeding",
  },
  {
    name: "Vessel Recognition",
    description:
      "With a Resolve + Awareness test at Difficulty 2 they can tell if a mortal has been fed on recently. A critical win lets them sense if the feed is recurring, meaning there is a chance it’s a herd member.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Feeding",
  },
  {
    name: "Eat Food",
    description: "Can consume food but still with no nourishment.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Mythic",
  },
  {
    name: "Cold Dead Hunger",
    description: "Add two dice to resist Hunger frenzy.",
    rating: 3,
    flaw: false,
    modifier: 2,
    group: "Mythic",
  },
  {
    name: "Pack Diablerie",
    description:
      "The character will always be the one to take the soul unless they otherwise choose during Diablerie. Additionally, if they help another consume the soul, they gain 5 experience points to spend in the same manner as if they'd committed the Diablerie themselves.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Mythic",
  },
  {
    name: "Luck of the Devil",
    description:
      "Once per session when misfortune occurs it can be redirected towards someone close to them for the victim to take the fall.",
    rating: 4,
    flaw: false,
    modifier: 0,
    group: "Mythic",
  },
  {
    name: "Nuit Mode",
    description:
      "The Kindred’s body does not revert to it’s death-state each night, enabling them to keep new haircuts and body modifications. They can mend these changes anytime as if they were Aggravated damage. This does not work for characters with BP higher than 1.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Mythic",
  },
  {
    name: "Unholy Will",
    description:
      "With two dots, add one die to any pool when resisting or contesting against an individual with True Faith when related to their faith. The character also suffers one less point of damage from holy sources. At four dots, add two dice and suffer two fewer points of damage.",
    rating: 2,
    flaw: false,
    modifier: 1,
    group: "Psychological",
  },
  {
    name: "Zealotry",
    description:
      "For each dot in this merit, once per session when succeeding with a normal roll that relates or aligns to the character's Conviction, turn it into a messy critical.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Psychological",
  },
  {
    name: "Penitence",
    description:
      "Once per session, take one point of self-inflicted Superficial Health Damage in exchange for one point of Superficial Willpower damage.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Psychological",
  },
  {
    name: "Soothed Beast",
    description:
      "With a SPC as an obsession, once per session they can ignore one Bestial or Messy Critical. Gain three Stains if they die.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Psychological",
  },
  {
    name: "False Love",
    description:
      "With a SPC as an obsession, when in their presence treat the character's treat Humanity as one higher (Max 10) for purposes of using Blush of Life, eating, drinking, or sexual intercourse. Gain three Stains if they die.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Psychological",
  },
  {
    name: "Check the Trunk",
    description:
      "Easy access to an armor or cache of tools, none of these items can exceed the value of something a Resources 2 character could access. Add two dice to Preperation Rolls.",
    rating: 1,
    flaw: false,
    modifier: 2,
    group: "Other",
  },
  {
    name: "Side Hustler",
    description:
      "Once per session they can get their hands on an item, information, or access to an event as if they had two dots in the related Resources, Contacts, or Influence.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Other",
  },
  {
    name: "Tempered Will",
    description:
      "They are always aware when someone is attempting to use Dominate or Presence against them. They may add two additional dice to resistance pools once per session, which can only be taken by those with no dots in Dominate or Presence.",
    rating: 3,
    flaw: false,
    modifier: 2,
    group: "Other",
  },
  {
    name: "Untouchable",
    description:
      "Once per story they are able to escape all official punishment for a crime that would otherwise see them destroyed.",
    rating: 5,
    flaw: false,
    modifier: 0,
    group: "Other",
  },
  {
    name: "Favored Blood",
    description:
      "Be able to purchase any Discipline even if they've never tasted the vitae of another vampire who has it. Cannot be taken with the Muddled Blood Flaw.",
    rating: 4,
    flaw: false,
    modifier: 0,
    group: "Caitiff",
  },
  {
    name: "Mark of Caine",
    description:
      "Gain two bonus dice on any attempt to intimidate or bully other vampires who believe in the myth of Caine. Anyone who attempts diablerie on the Caitiff cannot add their Blood Potency to the roll and failure results in a Bestial fail.",
    rating: 2,
    flaw: false,
    modifier: 2,
    group: "Caitiff",
  },
  {
    name: "Mockingbird",
    description:
      "For one night, if they've drank the Blood from another vampire, the Caitiff may utilize one of the Disciplines the vampire possesses. It cannot be a level higher than the Caitiff's own highest Discipline, it is rolled like a normal power except in powers that require a roll the Caitiff uses the donor's Discipline level and Caitiff's attributes. During this time the Caitiff suffers the donor vampire's Bane at the same Bane Severity and only one power can be used this way per night.",
    rating: 3,
    flaw: false,
    modifier: 0,
    group: "Caitiff",
  },
  {
    name: "Sun-Scarred",
    description:
      "The first turn of being exposed to sunlight take no Health damage, take 1 Aggravated Willpower damage, and automatically succeed on terror Frenzy. For the remainder of the scene, all damage from the sun is converted into Superficial damage.",
    rating: 5,
    flaw: false,
    modifier: 0,
    group: "Caitiff",
  },
  {
    name: "Uncle Fangs",
    description:
      "They have easy access to a local coterie of three to five thin-bloods, and treat this group as Allies even though they are undead. Cannot be taken with Liquidator.",
    rating: 3,
    flaw: false,
    modifier: 0,
    group: "Caitiff",
  },
  {
    name: "Anarch Comrades",
    description:
      "Befriended an Anarch group, and act as a one-dot Anarch Mawla.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Camarilla Contact",
    description:
      "Caught the attention of someone within the Camarilla, acts as a one-dot Camarilla Mawla.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Catenating Blood",
    description: "Can create Blood Bonds and embrace other thin-bloods.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Day Drinker",
    description:
      "Able to walk in the sun. Sunlight halves their Health Tracker (rounded up) and removes all vampiric abilities.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Lifelike",
    description:
      "Has a heartbeat, can eat food, and enjoy sexual activities. Most medical checks reveal nothing, as long as it's during the night.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Discipline Affinity",
    description:
      "Natural ability for one Discipline. Gain one dot and can retain additional levels at the experience cost of out-of-clan. Consuming matching resonance does not reward them with extra temporary dots.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Thin-blood Alchemist",
    description: "Gain one dot and one formula of Thin-blood Alchemy.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Vampiric Resilience",
    description: "Take damage like a regular vampire.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Abhorrent Blood",
    description:
      "With Blood so disgusting any vampire who attempts to drink from them must spend two points of Willpower each turn. Mortals and Thin-blood Alchemy are not affected by this.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Faith-Proof",
    description:
      "They are too close to mortality for True Faith to affect them.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Low Appetite",
    description:
      "When waking up at sunset with Hunger 0 or 1, roll two dice on the Rouse Check and take the highest between the two.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Lucid Dreamer",
    description:
      "Once per session, they can receive a clue from the previous night's memories or a hint about the story.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Mortality's Mien",
    description:
      "Appearing more mortal than most vampires their vampiric nature cannot be detected through auras. In addition, receive two dice in any attempt to make yourself appear mortal in other methods such as makeup.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Swift Feeder",
    description:
      "Able to slake one Hunger in one turn as well as lick the wound closed. This can only be used once per scene.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Thin-blood",
  },
  {
    name: "Blood Empathy",
    description:
      "The ghoul can feel if their regnant is in danger or otherwise, needs them immediately, this does not allow for telepathic communication.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Ghouls",
  },
  {
    name: "Unseemly Aura",
    description: "	Their aura has become indistinguishable from a Kindred.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Ghouls",
  },
  {
    name: "Apocryphal Texts",
    description:
      "The character possesses writings from one of the church's leaders or prominent figures. On applicable rolls gain two dice Intelligence rolls, and in social combat increase the Willpower damage modifier by 1.",
    rating: 1,
    flaw: false,
    modifier: 2,
    group: "Cults",
  },
  {
    name: "Traveling Preacher",
    description:
      "Having spread the cult's message where they go, reduce the difficulty on rolls to avoid the Second Inquisition by 1.",
    rating: 2,
    flaw: false,
    modifier: 2,
    group: "Cults",
  },
  {
    name: "Inspired Artist",
    description:
      "When using the cult's symbols or message in art, add a 1-die penalty to onlookers to resist Social rolls from cult members.",
    rating: 2,
    flaw: false,
    modifier: 1,
    group: "Cults",
  },
  {
    name: "Memories of the Fallen (Thin-bloods)",
    description:
      "On Blood Alchemy rolls related to Ashe, one rolled 10 counts as two 10s. Two rolled 10s still count as four.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Ashfinders",
  },
  {
    name: "Streamer",
    description:
      "Once per story, the character can call upon their fanbase to perform something simple and nonviolent for them.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Ashfinders",
  },
  {
    name: "Gardener",
    description:
      "Being selected members from the faith, this merit is equivalent to Herd for the Bahari religion.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Bahari",
  },
  {
    name: "Dark Mother's Song",
    description:
      "Add three dice in Manipulation rolls when convincing others to worship Lilith.",
    rating: 2,
    flaw: false,
    modifier: 3,
    group: "Bahari",
  },
  {
    name: "Fire Resistant",
    description:
      "Convert Aggravated Health damage from fire to Superficial Health damage equal to their Blood Potency for one Rouse Check instead of three during daysleep.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Church of Caine",
  },
  {
    name: "Vigilant",
    description:
      "The character knows when they are being watched unless it's through supernatural means, they stil must roll to know who and where from.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Church of Set",
  },
  {
    name: "Fixer",
    description: "Once per story, call in a favor or threaten a former client.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Church of Set",
  },
  {
    name: "Go to Ground",
    description: "Add two dice on rolls when evading pursuit.",
    rating: 1,
    flaw: false,
    modifier: 2,
    group: "Church of Set",
  },
  {
    name: "Insidious Whispers",
    description:
      "When making a Social roll to undermine a Conviction, one rolled 10 counts as two 10s. Two rolled 10s still count as four.",
    rating: 2,
    flaw: false,
    modifier: 0,
    group: "Cult of Shalim",
  },
  {
    name: "Gematria",
    description:
      "The ability to understand a coded cipher allowing both encrypting and decrypting messages.",
    rating: 1,
    flaw: false,
    modifier: 0,
    group: "Cult of Shalim",
  },
  {
    name: "Bull-Slayer",
    description:
      "During Extended Tests, The character can reroll up to three regular dice without spending Willpower once per scene.",
    rating: 3,
    flaw: false,
    modifier: 0,
    group: "Mithraic Mysteries",
  },
  {
    name: "Bargainer",
    description: "Reduce the Difficulty to assess a transaction by 1.",
    rating: 1,
    flaw: false,
    modifier: 2,
    group: "Mithraic Mysteries",
  },
  {
    name: "Archangel's Grace",
    description:
      "Replace the Athletics Skill with the Performance Skill or vice versa when doing something akin to heavy cardio.",
    rating: 3,
    flaw: false,
    modifier: 0,
    group: "Nephilim",
  },
];

module.exports.flawsOptions = [];
module.exports.havenOptions = [];
module.exports.backgroundsOptions = [];
module.exports.loresheetsOptions = [];
